import React from 'react'
import MEModal from '../../components/MEModal'
import { useStateValue } from '@State'
import { archiveSection } from '../actions'
import { toast } from '@CommonComponents/toast'
import { Button } from '@CommonComponents/buttons'

export const archiveSectionItem = {
  id: 'archive-section',
  label: 'Archive Students',
  icon: 'fa-light fa-archive',
}

export const ArchiveSectionModal = ({ section, sectionName, show, close }) => {
  const [currentState, dispatch] = useStateValue()

  const submit = async () => {
    let data = {
      section_id: section,
      pageNum: currentState.currentCourseMemPage,
      archivedPageNum: currentState.currentArchivePage,
    }
    close()
    try {
      let resp = await archiveSection(data, dispatch)
      if (resp.status === 200) {
        toast.info('Successfully archived section')
      } else {
        toast.error(resp.data.error)
      }
    } catch (err) {
      toast.error('There was a problem archiving the section.')
    }
  }

  return (
    <MEModal show={show} close={close} title={'Archive Section'}>
      <form onSubmit={e => e.preventDefault()}>
        <p>
          Are you sure you want to archive all students in section{' '}
          {sectionName}?
        </p>
        <Button
          className="me-btn me-btn-primary"
          type="button"
          onClick={submit}
        >
          Archive students
        </Button>
      </form>
    </MEModal>
  )
}
